import { useState, useEffect } from 'react';
import moment from 'moment';
import { TextField } from '@mui/material';

export interface ServiceTimeCounterProps {
    service_time: number | null;
    service_time_start: string | null;
    service_time_end: string | null;
    returnInput?: boolean;
}

function calcularSegundosHorarioEspecifico(dataInicial: moment.Moment, dataFinal: moment.Moment): number {
    let tempoTrabalhado: number = 0; // Em minutos

    // Verifica se a data inicial está dentro do horário de trabalho
    if (dataInicial.hours() < 8) {
        dataInicial.hours(8).minutes(0).seconds(0).milliseconds(0);
    } else if (dataInicial.hours() >= 18) {
        dataInicial.hours(17).minutes(59).seconds(59).milliseconds(999);
    }

    // Verifica se a data final está dentro do horário de trabalho
    if (dataFinal.hours() < 8) {
        dataFinal.hours(8).minutes(0).seconds(0).milliseconds(0);
    } else if (dataFinal.hours() >= 18) {
        dataFinal.hours(17).minutes(59).seconds(59).milliseconds(999);
    }

    const intervalo: number = dataFinal.diff(dataInicial, 'days');

    // Loop através de cada dia no intervalo
    for (let i = 0; i <= intervalo; i++) {
        const data = moment(dataInicial).add(i, 'days');

        // Verifica se o dia é útil (segunda a sexta-feira) e está dentro do horário especificado
        if (
            data.isoWeekday() >= 1 &&
            data.isoWeekday() <= 5 &&
            data.hours() >= 8 &&
            data.hours() < 18
        ) {
            // Calcula o tempo dentro do horário de trabalho
            const inicio = moment.max(data, dataInicial); // Hora de início do trabalho no dia
            const fim = moment.min(moment(data).hours(18).minutes(0).seconds(0).milliseconds(0), dataFinal); // Hora de término do trabalho no dia
            tempoTrabalhado += fim.diff(inicio, 'seconds');
        }
    }

    return tempoTrabalhado < 0 ? 0 : tempoTrabalhado;
}

function segundosParaHoraMinutos(segundos: number): string {
    var horas = Math.floor(segundos / 3600);
    var minutos = Math.floor((segundos % 3600) / 60);
    
    return horas.toString().padStart(2, '0') + ":" + minutos.toString().padStart(2, '0');
}

export function calculateServiceTime(start: string | null, end: string | null, currentServiceTime: number | null): { totalSeconds: number, formatedTime: string } {
    let totalTimeInSeconds = currentServiceTime || 0;

    if (end === null && start) {
        const startTime = moment(start);
        const currentTime = moment();
        totalTimeInSeconds += calcularSegundosHorarioEspecifico(startTime, currentTime);
    }    
    
    return { formatedTime: segundosParaHoraMinutos(totalTimeInSeconds), totalSeconds: totalTimeInSeconds };
}

export function ServiceTimeCounter({ service_time, service_time_end, service_time_start, returnInput }: ServiceTimeCounterProps) {
    const [serviceTime, setServiceTime] = useState<string>('00:00');
    
    useEffect(() => {
        const updatedServiceTime = calculateServiceTime(service_time_start, service_time_end, service_time);
        setServiceTime(updatedServiceTime.formatedTime);
    }, [service_time_start, service_time_end, service_time]);

    return (
        <>
            {returnInput ? (
                <TextField
                    name="service_time"
                    label="Tempo de atendimento"
                    margin="dense"
                    variant="outlined"
                    disabled
                    value={serviceTime}
                    fullWidth
                />
            ) : (
                serviceTime
            )}
        </>
    );
}
